<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height class="primary">
        <slot />
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {}
</script>

<style></style>
